import { Link, useLocation } from 'react-router-dom';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export default function NotFound() {
  useDocumentTitle('页面未找到 - 疯狂试爱2影视内容站', '你访问的页面不存在，请返回首页继续浏览。');
  const location = useLocation();

  return (
    <section className="relative flex min-h-[70vh] w-full items-center justify-center overflow-hidden bg-primary-900 px-4 py-20">
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20empty%20dark%20movie%20theater%20screen%20glowing%20deep%20blue%20with%20warm%20orange%20projector%20light%20beams%2C%20abandoned%20seats%2C%20moody%20atmospheric%20cinematic%20lighting%2C%20dark%20simple%20background%20with%20negative%20space%2C%20high%20detail%2C%2035mm%20look&width=1600&height=900&seq=fsa2-404&orientation=landscape"
          alt="页面未找到"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-primary-950/80"></div>

      <div className="relative z-10 flex w-full max-w-xl flex-col items-center text-center">
        <span className="font-heading text-6xl font-black text-accent-400 md:text-8xl">404</span>
        <h1 className="mt-4 font-heading text-xl font-bold text-background-50 md:text-2xl">抱歉，页面未找到</h1>
        <p className="mt-3 text-sm leading-relaxed text-primary-100 md:text-base">
          你访问的页面可能已被移除或链接有误。不妨回到首页，继续探索《疯狂试爱2》的精彩内容。
        </p>
        <p className="mt-2 break-all font-mono text-xs text-primary-300">{location.pathname}</p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/news"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-200/50 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-800/60"
          >
            <i className="ri-newspaper-line"></i>
            浏览资讯
          </Link>
        </div>
      </div>
    </section>
  );
}